module.exports = __webpack_public_path__ + "static/nasb-looseleaf-bible-new-american-standard-bible-pages-only-25e5a1daf12a03a36c257de26719fc20.jpg";